import axios, { AxiosError } from 'axios';

export  function  Zip_Code_Api(cep:String ) {
    const api = 
    axios.create({
        baseURL: 'https://viacep.com.br/ws/'+cep+'/json/', // URL da sua API
        timeout: 5000, // Tempo máximo de espera por uma resposta (opcional)
        headers: {
            //'Content-Type': 'multipart/form-data',
            // Authorization: `Bearer ${token}`
        },  

    }) 

    api.interceptors.response.use(
        response => {
            return response;
        },
        (error: AxiosError) => {
            if(error.response?.status === 401){
                // qualquer erro nao autorizado devemos deslogar o usuario 
                if(typeof window !== undefined)
                {
                    // chama funcao para deslogar usuario 
                } else
                {
                  return 401
                }
            }
            return 401
        }
    ) 


    return api
}



